var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"homecard2"},on:{"click":function($event){return _vm.MoreDetail(_vm.data)}}},[_c('div',[_c('h5',{staticClass:"CardButton fontMfontBookedium primarycolor",class:[_vm.data.selected==true?'selected':'CardButton']},[_vm._v(" "+_vm._s(_vm.data.title)+" "+_vm._s(_vm.data.Name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }